import Modal from "react-bootstrap/Modal";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import AdminCreateSession from "./AdminCreateSession";
import MatchMakerSettings from "./admin/MatchMakerSettings";
import SessionList from "./SessionList";
import Swal from "sweetalert2";
import { THEME_COLOR } from "../config/club"; // Ensure path is correct

export default function SettingsModal({
  show,
  onClose,
  clubId,
  ToastShow,
  colsCount,
  setColsCount,
  longWaitThreshold,
  setLongWaitThreshold,
  lookForPlayers,
  setLookForPlayers,
  maxLevelDiff,
  setMaxLevelDiff,
  showAutoMatch,
  setShowAutoMatch,
  courts,
  handleCourtChange,
  limitTeammatesEnabled,
  setLimitTeammatesEnabled,
  limitRivalsEnabled,
  setLimitRivalsEnabled,
  maxTeammates,
  setMaxTeammates,
  maxRivals,
  setMaxRivals,
  maxTeamDiff,
  setMaxTeamDiff,
}) {
  const themeAlpha = (opacity) => `${THEME_COLOR}${opacity}`;

  function DangerZone({ clubId }) {
    const resetSession = async () => {
      const result = await Swal.fire({
        title: "Reset current session?",
        text: "Queue, matches, and players will be cleared",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        background: "var(--surface-bg)",
        customClass: {
          popup: 'rounded-4'
        }
      });

      if (!result.isConfirmed) return;
    };

    return (
      <div className="p-4 rounded-4 border border-danger-subtle bg-danger-subtle bg-opacity-10">
        <h6 className="fw-bold text-danger mb-2">Danger Zone</h6>
        <p className="small text-muted mb-3">
          These actions are irreversible. Please proceed with caution.
        </p>
        <button
          className="btn btn-danger px-4 rounded-pill shadow-sm fw-bold"
          disabled
          onClick={resetSession}
        >
          Reset Active Session
        </button>
      </div>
    );
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      centered
      scrollable
      contentClassName="border-0 shadow-lg rounded-5"
    >
      <Modal.Header closeButton className="border-0 px-4 pt-4">
        <Modal.Title className="fw-bold d-flex align-items-center" style={{ color: THEME_COLOR }}>
          <div
            className="rounded-3 d-flex align-items-center justify-content-center me-3"
            style={{ width: 40, height: 40, backgroundColor: themeAlpha('10') }}
          >
            <i className="bi bi-gear-fill"></i>
          </div>
          Club Settings
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 pb-4">
        <Tabs
          defaultActiveKey={(colsCount && longWaitThreshold) ? "matchMaking" : "sessions"}
          className="custom-tabs mb-4 border-0"
        >
          {(colsCount && longWaitThreshold) && (
            <Tab eventKey="matchMaking" title="Match Making">
              <div className="pt-2">
                <MatchMakerSettings
                  colsCount={colsCount}
                  setColsCount={setColsCount}
                  // autoRotation={autoRotation}
                  // setAutoRotation={setAutoRotation}
                  longWaitThreshold={longWaitThreshold}
                  setLongWaitThreshold={setLongWaitThreshold}
                  lookForPlayers={lookForPlayers}
                  setLookForPlayers={setLookForPlayers}
                  maxLevelDiff={maxLevelDiff}
                  setMaxLevelDiff={setMaxLevelDiff}
                  showAutoMatch={showAutoMatch}
                  setShowAutoMatch={setShowAutoMatch}
                  THEME_COLOR={THEME_COLOR}
                  courts={courts}
                  handleCourtChange={handleCourtChange}
                  limitTeammatesEnabled={limitTeammatesEnabled}
                  setLimitTeammatesEnabled={setLimitTeammatesEnabled}
                  limitRivalsEnabled={limitRivalsEnabled}
                  setLimitRivalsEnabled={setLimitRivalsEnabled}
                  maxTeammates={maxTeammates}
                  setMaxTeammates={setMaxTeammates}
                  maxRivals={maxRivals}
                  setMaxRivals={setMaxRivals}
                  maxTeamDiff={maxTeamDiff}
                  setMaxTeamDiff={setMaxTeamDiff}
                />
              </div>
            </Tab>
          )}
          <Tab eventKey="sessions" title="Sessions">
            <div className="pt-2">
              <AdminCreateSession clubId={clubId} ToastShow={ToastShow} />
              <div className="my-4 border-top opacity-50"></div>
              <SessionList clubId={clubId} />
            </div>
          </Tab>

          <Tab eventKey="danger" title="Danger Zone">
            <div className="pt-2">
              <DangerZone clubId={clubId} />
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>

      {/* Modern Tab Styling Injection */}
      <style>{`
  .modal-content {
    border-radius: 28px !important;
    background: var(--card-bg);
    color: var(--text-color);
  }

  .custom-tabs .nav-link {
    border: none !important;
    color: var(--text-muted);
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 12px;
    margin-right: 8px;
    transition: all 0.2s;
  }

  .custom-tabs .nav-link.active {
    background-color: ${themeAlpha('10')} !important;
    color: ${THEME_COLOR} !important;
  }

  .custom-tabs .nav-link:hover:not(.active) {
    background: var(--surface-bg);
  }

  .btn-close:focus {
    box-shadow: none;
  }
`}</style>
    </Modal>
  );
}